import moment from "moment";
import { ButtonGroup } from "reactstrap";
import { Button } from "reactstrap";
import { Input } from "reactstrap";
import styled from "styled-components";

export default function DateRange({
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    increment
}: {
    startDate: string;
    endDate: string;
    setStartDate: React.Dispatch<React.SetStateAction<string>>;
    setEndDate: React.Dispatch<React.SetStateAction<string>>;
    increment: 'day' | 'week' | 'month'
}) {

    const changeWeek = (add: boolean) => {
        const delta = add ? 'add' : 'subtract';
        setStartDate(date => moment(date)[delta](1, increment).format('YYYY-MM-DD'));
        setEndDate(date => moment(date)[delta](1, increment).format('YYYY-MM-DD'));
    }

    return (
        <Container>
            <h4 className={'d-inline'}>Date Range: </h4>
            <Input
                type={'date'}
                style={{ width: '200px' }}
                className={'d-inline'}
                value={startDate}
                disabled
            />
            <h4 className={'mx-1 d-inline'}>to</h4>
            <Input
                type={'date'}
                style={{ width: '200px' }}
                className={'d-inline'}
                value={endDate}
                disabled
            />
            <ButtonGroup className={'d-inline ml-3'}>
                <Button
                    className={'mr-2'}
                    onClick={() => changeWeek(false)}
                >
                    Prev. {increment}
                </Button>
                <Button
                    onClick={() => changeWeek(true)}
                >
                    Next {increment}
                </Button>
            </ButtonGroup>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
`;